import React from 'react';
interface IconProps {
  className?: string;
}
export function FlameIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-297">
      <path d="M12 22c-4.97 0-7-3.58-7-7 0-3.07 2.17-5.64 3.5-7 .33 2.5 2 4.5 3.5 5.5 1-.73 2.5-3.1 2.5-5.5 2.17 1.77 4.5 4.53 4.5 7 0 3.42-2.03 7-7 7z" data-id="element-298" />
    </svg>;
}
export function SnowflakeIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-299">
      <line x1="12" y1="2" x2="12" y2="22" data-id="element-300" />
      <line x1="2" y1="12" x2="22" y2="12" data-id="element-301" />
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" data-id="element-302" />
      <line x1="19.07" y1="4.93" x2="4.93" y2="19.07" data-id="element-303" />
      <line x1="12" y1="2" x2="14" y2="5" data-id="element-304" />
      <line x1="12" y1="2" x2="10" y2="5" data-id="element-305" />
      <line x1="12" y1="22" x2="14" y2="19" data-id="element-306" />
      <line x1="12" y1="22" x2="10" y2="19" data-id="element-307" />
      <line x1="2" y1="12" x2="5" y2="10" data-id="element-308" />
      <line x1="2" y1="12" x2="5" y2="14" data-id="element-309" />
      <line x1="22" y1="12" x2="19" y2="10" data-id="element-310" />
      <line x1="22" y1="12" x2="19" y2="14" data-id="element-311" />
    </svg>;
}
export function ShieldIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-312">
      <path d="M12 2l8 4v6c0 5.25-3.5 8.75-8 10-4.5-1.25-8-4.75-8-10V6l8-4z" data-id="element-313" />
      <polyline points="9 12 11 14 15 10" data-id="element-314" />
    </svg>;
}
export function LeafIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-315">
      <path d="M6 21c3-3 7-5 11-8 0-5-3-9-8-11C7 5 4 9 4 14c0 2 .5 4 2 7z" data-id="element-316" />
      <path d="M9 17c2-2 4.5-3.5 7-5.5" data-id="element-317" />
    </svg>;
}
export function DropletIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-318">
      <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0L12 2.69z" data-id="element-319" />
    </svg>;
}
export function CheckCircleIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-320">
      <circle cx="12" cy="12" r="10" data-id="element-321" />
      <polyline points="9 12 11 14 15 10" data-id="element-322" />
    </svg>;
}
export function XCircleIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-323">
      <circle cx="12" cy="12" r="10" data-id="element-324" />
      <line x1="15" y1="9" x2="9" y2="15" data-id="element-325" />
      <line x1="9" y1="9" x2="15" y2="15" data-id="element-326" />
    </svg>;
}
export function ClockIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-327">
      <circle cx="12" cy="12" r="10" data-id="element-328" />
      <polyline points="12 6 12 12 16 14" data-id="element-329" />
    </svg>;
}
export function BookIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-330">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-331" />
      <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15z" data-id="element-332" />
      <line x1="9" y1="7" x2="16" y2="7" data-id="element-333" />
      <line x1="9" y1="11" x2="14" y2="11" data-id="element-334" />
    </svg>;
}
export function CalendarIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-335">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-336" />
      <line x1="16" y1="2" x2="16" y2="6" data-id="element-337" />
      <line x1="8" y1="2" x2="8" y2="6" data-id="element-338" />
      <line x1="3" y1="10" x2="21" y2="10" data-id="element-339" />
      <line x1="8" y1="14" x2="8" y2="14.01" data-id="element-340" />
      <line x1="12" y1="14" x2="12" y2="14.01" data-id="element-341" />
      <line x1="16" y1="14" x2="16" y2="14.01" data-id="element-342" />
      <line x1="8" y1="18" x2="8" y2="18.01" data-id="element-343" />
      <line x1="12" y1="18" x2="12" y2="18.01" data-id="element-344" />
    </svg>;
}
export function SmoothieIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-345">
      <path d="M6 8h12l-1.5 12a2 2 0 0 1-2 1.8h-5a2 2 0 0 1-2-1.8L6 8z" data-id="element-346" />
      <path d="M5 8h14" data-id="element-347" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" data-id="element-348" />
      <line x1="12" y1="12" x2="12" y2="16" data-id="element-349" />
      <path d="M15 3l2-1" data-id="element-350" />
    </svg>;
}
export function ChevronDownIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-351">
      <polyline points="6 9 12 15 18 9" data-id="element-352" />
    </svg>;
}
export function DownloadIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-353">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-354" />
      <polyline points="7 10 12 15 17 10" data-id="element-355" />
      <line x1="12" y1="15" x2="12" y2="3" data-id="element-356" />
    </svg>;
}
export function TargetIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-357">
      <circle cx="12" cy="12" r="10" data-id="element-358" />
      <circle cx="12" cy="12" r="6" data-id="element-359" />
      <circle cx="12" cy="12" r="2" data-id="element-360" />
    </svg>;
}
export function AnchorIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-361">
      <circle cx="12" cy="5" r="3" data-id="element-362" />
      <line x1="12" y1="22" x2="12" y2="8" data-id="element-363" />
      <path d="M5 12H2a10 10 0 0 0 20 0h-3" data-id="element-364" />
    </svg>;
}
export function AlertTriangleIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-365">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-id="element-366" />
      <line x1="12" y1="9" x2="12" y2="13" data-id="element-367" />
      <line x1="12" y1="17" x2="12" y2="17.01" data-id="element-368" />
    </svg>;
}
export function SparkleIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-369">
      <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" data-id="element-370" />
    </svg>;
}
export function GiftIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-371">
      <polyline points="20 12 20 22 4 22 4 12" data-id="element-372" />
      <rect x="2" y="7" width="20" height="5" data-id="element-373" />
      <line x1="12" y1="22" x2="12" y2="7" data-id="element-374" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" data-id="element-375" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" data-id="element-376" />
    </svg>;
}
export function MapPinIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-377">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-378" />
      <circle cx="12" cy="10" r="3" data-id="element-379" />
    </svg>;
}
export function ClipboardIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-380">
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" data-id="element-381" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" data-id="element-382" />
      <line x1="9" y1="14" x2="15" y2="14" data-id="element-383" />
      <line x1="9" y1="18" x2="15" y2="18" data-id="element-384" />
      <line x1="9" y1="10" x2="15" y2="10" data-id="element-385" />
    </svg>;
}
export function MessageIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-386">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" data-id="element-387" />
    </svg>;
}
export function StarIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-388">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-389" />
    </svg>;
}